import { getDailyBlocksCounts } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const GetDailyBlockCounts = async (startDate, endDate, accessToken) => {
  try {
    const response = await getDailyBlocksCounts(startDate, endDate, accessToken);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default GetDailyBlockCounts;
